export default __webpack_public_path__ + "static/media/Sume_LogoPrincipal.e45d6877.png";